import { DataDrivenPropertyValueSpecification, LayerSpecification } from "mapbox-gl";

import { IMG_MARKER_GENERAL } from "~/modules/map/mapStyles";

import { makeOnHoverExpression } from "./makeOnHoverExpression";

export default function generateIconMapStyle(
    sourceId: string,
    color = "#FFFFFF",
    hoveredFeatureId?: string,
): LayerSpecification[] {
    const highlightColor = "#FFA500";

    const makeHoverColorExpression = (baseColor: string): DataDrivenPropertyValueSpecification<string> => {
        if (!hoveredFeatureId) {
            return baseColor;
        }

        return ["case", ["==", ["get", "id"], hoveredFeatureId], highlightColor, baseColor];
    };

    return [
        // Symbol
        {
            id: `${sourceId}-other-points`,
            source: sourceId,
            type: "symbol",
            slot: "top",
            paint: {
                "icon-color": "red",
                "icon-opacity": makeOnHoverExpression({
                    defaultValue: 0.6,
                    hoveredMapEditorFeatureId: hoveredFeatureId,
                    hoveredValue: 1,
                }),
            },
            layout: {
                "icon-size": makeOnHoverExpression({
                    defaultValue: 0.4,
                    hoveredMapEditorFeatureId: hoveredFeatureId,
                    hoveredValue: 0.6,
                }),
                "icon-image": IMG_MARKER_GENERAL,
                "icon-offset": [0, -10],
                "icon-ignore-placement": true,
                "icon-allow-overlap": true,
            },
            filter: ["==", "$type", "Point"],
        },

        // Lines
        {
            id: `${sourceId}-other-lines`,
            source: sourceId,
            type: "line",
            slot: "top",
            layout: {
                "line-cap": "round",
                "line-join": "round",
            },
            paint: {
                "line-width": makeOnHoverExpression({
                    defaultValue: 6,
                    hoveredMapEditorFeatureId: hoveredFeatureId,
                    hoveredValue: 8,
                }),
                "line-border-color": "#FFFFFF",
                "line-border-width": 2,
                "line-color": makeHoverColorExpression(color),
            },
            filter: ["==", "$type", "LineString"],
        },

        // Polygons
        {
            id: `${sourceId}-other-polygons-outline`,
            source: sourceId,
            type: "line",
            slot: "top",
            paint: {
                "line-color": makeHoverColorExpression(color),
                "line-width": makeOnHoverExpression({
                    defaultValue: 3.0,
                    hoveredMapEditorFeatureId: hoveredFeatureId,
                    hoveredValue: 5,
                }),
            },
            filter: ["==", "$type", "Polygon"],
        },
        {
            id: `${sourceId}-other-polygons-fill`,
            source: sourceId,
            type: "fill",
            slot: "top",
            paint: {
                "fill-color": makeHoverColorExpression(color),
            },
            filter: ["==", "$type", "Polygon"],
        },
    ];
}
